import React from "react";

export function shouldShowObjTreeAdr({
    env = process.env.REACT_APP_NAME_ENV,
    hash = typeof window !== "undefined" ? window.location.hash : "",
    row = {},
} = {}) {
    return Boolean(env === "renergy" && row.isG && row.adr && hash === "#/energoobjects");
}

export function objNameFilterValue(row, env = process.env.REACT_APP_NAME_ENV) {
    if (env === "renergy" && row && row.isG && row.adr) {
        return `${row.t} ${row.adr}`;
    }
    return row ? row.t : "";
}

export default function ObjNameCell(props) {
    const row = props.data && props.data.data ? props.data.data : {};
    const showAdr = shouldShowObjTreeAdr({ row });
    return (
        <div className="tree-obj-name">
            <div>{row.t}</div>
            {showAdr ? <div className="tree-obj-adr">{row.adr}</div> : null}
        </div>
    );
}
